import { Field, Form, Formik, useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { inValidCharacterForStoreName } from "../../../../../constants/constants";
import { useStore } from "../../../../../contexts/store-provider";
import { businessTypeInitialState } from "../../../../../core/initialState/master-settings-state";
import LoaderButton from "../../../../../shared-components/button/loader-button";
import FormikFormInput from "../../../../../shared-components/FormikFormHandlers/FormikFormInput";
import FormikFormInputForRegexCheck from "../../../../../shared-components/FormikFormHandlers/FormikFormInputForRegexCheck";
import Label from "../../../../../shared-components/label/label";
import { AddEditBusinessTypeValidationSchema } from "../../../../../shared-components/FormikFormHandlers/FormikValidationSchema";
interface IProps {
  id: number;
  initialValues: any;
  submitHandler: (data: any) => void;
  addUpdateInProgress: boolean;
  actionSuccess: boolean;
  onCancelEdit: () => void;
}

const AddBusinessTypeSettingsForm: React.FC<IProps> = (props: IProps) => {
  const {
    submitHandler,
    addUpdateInProgress,
    actionSuccess,
    initialValues,
    id,
    onCancelEdit,
  } = props;
  const { masterManagementStore } = useStore();
  const { addUpdateBusinessTypeSettingState } = masterManagementStore;
  let resetPresForm = () => {};
  const [initialValue, setInitialValue] = useState<any>({
    ...initialValues,
  });
  const FormObserver: React.FC = () => {
    const { values } = useFormikContext<any>();
    return null;
  };

  /**
   * This functional component stores the reset form function in the resetPresentForm variable
   */
  const ResettingForm = () => {
    const { resetForm } = useFormikContext();
    resetPresForm = resetForm; // Store the value of resetForm in this variable
    return null;
  };

  useEffect(() => {
    if (addUpdateBusinessTypeSettingState.success) {
      setInitialValue({ ...businessTypeInitialState });
      resetPresForm();
    }
  }, [addUpdateBusinessTypeSettingState.success]);

  // useEffect(() => {
  //   if (addUpdateBusinessTypeSettingState.success) {
  //     setInitialValue({ ...businessTypeInitialState });
  //   } else {
  //     setInitialValue({ ...initialValues });
  //   }
  // }, [initialValues, addUpdateBusinessTypeSettingState.success]);

  useEffect(() => {
    if (initialValues) {
      setInitialValue({ ...initialValues });
    }
  }, [initialValues]);

  return (
    <>
      <Formik
        initialValues={{ ...initialValue }}
        enableReinitialize
        validationSchema={AddEditBusinessTypeValidationSchema}
        onSubmit={async (values: any) => {
          submitHandler(
            id > 0
              ? { ...values, Id: id }
              : {
                  Description: values.Description,
                  BusinessType: values.BusinessType,
                }
          );
        }}
      >
        {({ values, resetForm }) => (
          <>
            <Form className="setting-form" noValidate>
              <FormObserver />
              <Row className="position-relative g-xl-3 g-2">
                <Col xs={12} md={5} lg={5} xl={5}>
                  <Label
                    className="form-label"
                    required={true}
                    label="business_type"
                  />
                  <Field
                    className="form-control"
                    aria-label="Default select example"
                    name="BusinessType"
                    placeholder="business_type"
                    as={FormikFormInput}
                    invalidcharacter={inValidCharacterForStoreName}
                  />
                </Col>
                <Col xs={12} md={5} lg={5} xl={5}>
                  <Label className="form-label" label="description" />
                  <Field
                    className="form-control"
                    aria-label="Default select example"
                    name="Description"
                    placeholder="description"
                    as={FormikFormInput}
                    validcharacter={[
                      "・",
                      "／",
                      "－",
                      "～",
                      "＋",
                      "（",
                      "）",
                      "［",
                      "］",
                      "※",
                      "：",
                      "★",
                      "☆",
                      "◎",
                      "○",
                      "●",
                      "◆",
                      "◇",
                      "■",
                      "□",
                      "→",
                      "⇒",
                      "♪",
                      "(",
                      ")",
                      "【",
                      "】",
                      "￥",
                      '"',
                      "＜",
                      "＞",
                      "！",
                      "？",
                      "↓",
                      "↑",
                      "←",
                      "．",
                      '"',
                      "゛",
                      "'",
                      "'",
                      '"',
                      '"',
                      "、",
                      "。",
                      "《",
                      "》",
                      "+",
                      "-",
                      "[",
                      "]",
                      "|",
                      "*",
                      "&",
                      "/",
                      ".",
                      "!",
                      "@",
                      "#",
                      "$",
                      "%",
                      "^",
                      "_",
                      "`",
                      "{",
                      "}",
                      "?",
                      ";",
                      ":",
                      ",",
                      "=",
                      "~",
                      "<",
                      ">",
                    ]}
                  />
                  <p className="small text-muted text-end mt-1">{`${
                    values.Description ? values.Description.length : 0
                  }/300`}</p>
                </Col>
                <Col xs={12} md={2} lg={2} xl={2}>
                  <LoaderButton
                    type="submit"
                    className="label-top-margin"
                    isLoading={addUpdateInProgress}
                    disabled={addUpdateInProgress}
                    text={id > 0 ? "button_update" : "add"}
                  />
                  {id > 0 && (
                    <LoaderButton
                      type="button"
                      className="label-top-margin ms-2"
                      variant="danger"
                      onClick={() => {
                        onCancelEdit();
                        setInitialValue({ ...businessTypeInitialState });
                        resetPresForm();
                        resetForm({ values: businessTypeInitialState });
                      }}
                      isLoading={false}
                      disabled={addUpdateInProgress}
                      text="button_cancel"
                    />
                  )}
                </Col>
              </Row>

              <ResettingForm />
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};

export default observer(AddBusinessTypeSettingsForm);
